import React from 'react';
import { Box } from '@chakra-ui/react';
import ProfileForm from '../../components/forms/ProfileForm';

export default function ProfilePage() {
  return (
    <Box p={4}>
      <ProfileForm />
    </Box>
  );
}
